import React from "react";
import { classnames } from "../../utils/text";
//  form css
const Textarea = ({
  name,
  placeholder,
  value = '',
  maxLength,
  onChange = () => { },
  className,
  textareaClassName,
  height = "107px",
  minHeight = "107px",
  readOnly = false,
  ...props
}) => {
  return (
    <div
      className={classnames("component-textarea-wrap", className)}
      {...props}
    >
      <textarea
        className={classnames("component-textarea", textareaClassName)}
        name={name}
        placeholder={placeholder}
        value={value || ''}
        onChange={onChange}
        maxLength={maxLength}
        style={{ resize: "none", height, minHeight }}
        readOnly={readOnly}
      ></textarea>
      {maxLength && (
        <p className="length-check">
          {`${(value && value.length) || 0}`}
          <span className="total-length">{`/${maxLength}자`}</span>
        </p>
      )}
    </div>
  );
};
export default Textarea;
